import { render, staticRenderFns } from "./PromotionRowOfferPresentation.vue?vue&type=template&id=67327658&scoped=true"
import script from "./PromotionRowOfferPresentation.vue?vue&type=script&lang=ts&setup=true"
export * from "./PromotionRowOfferPresentation.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./PromotionRowOfferPresentation.vue?vue&type=style&index=0&id=67327658&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67327658",
  null
  
)

export default component.exports